import React, {Component} from 'react'
import IdleTimer from 'react-idle-timer';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {setUserIdle} from "../../actions/IdleActions";
import IdleModalComponent from "./IdleModalComponent";
import Logger from "../../helpers/Logger";

class IdleComponent extends Component {
    _onActive() {
        //do nothing when user is active
    }

    _onIdle() {
        if (!this.props.idle) {
            window.WaavoModalBox.callStaticModal({
                modalId: 'idle-modal',
                closeOnBackdrop: false
            });
        }
        this.props.setUserIdle();
    }

    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in IdleComponent', error.toString());
    }

    render() {
        return (
            <div>
                <IdleTimer
                    ref="idleTimer"
                    element={document}
                    activeAction={this._onActive}
                    idleAction={this._onIdle.bind(this)}
                    timeout={this.props.timeout}
                    format="MM-DD-YYYY HH:MM:ss.SSS">
                </IdleTimer>
                <IdleModalComponent translations={this.props.translations}/>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setUserIdle
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        idle: state.IdleReducer.idle,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IdleComponent);




// WEBPACK FOOTER //
// ./src/components/idle/IdleComponent.js